module.exports = __webpack_public_path__ + "media/images/home/focus_scan-cb9125e86a9b7d8dae97c1415e3e4677.png";